<script lang="ts">
  import type { Snippet } from "svelte";
  import type { SvelteHTMLElements } from "svelte/elements";

  import { themeStore } from "$routes/(microsites)/gpu-glossary/_lib/gpu-glossary";

  type Props = SvelteHTMLElements["pre"] & {
    lang?: string | null;
    children?: Snippet;
  };
  let { children, lang }: Props = $props();
</script>

{#if lang}
  <div
    class="code-block rounded-sm border"
    style:background-color={$themeStore.primary[5]}
    style:border-color={$themeStore.primary[20]}
    data-lang={lang}
  >
    <div
      class="rounded-t border-b px-3 py-1.5 font-mono text-xs"
      style:background-color={$themeStore.primary[20]}
      style:border-color={$themeStore.primary[20]}
      style:color={$themeStore.primary[60]}
    >
      {lang}
    </div>
    <pre
      class="m-0 overflow-x-auto p-4 font-mono text-sm leading-relaxed break-words whitespace-pre-wrap"
      style:color={$themeStore.primary[80]}>{@render children?.()}</pre>
  </div>
{:else}
  <pre>{@render children?.()}</pre>
{/if}

<style>
  .code-block {
    margin: 1rem 0;
    transition: border-color 0.2s ease;
  }

  .code-block:hover {
    border-color: #666;
  }
</style>
